import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog, Typography } from '@mui/material';
import { VideoLabel } from '@mui/icons-material';
import {
  IStateProps,
  IDispatchProps,
  IProps,
} from './interfaces';
import Button from '../../Shared/VaultButton';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogActionsOverride,
  ActionContainer,
} from '../../Shared/styles/dialog';
import GameScheduleForm from '../GameScheduleForm/component';
import { IAppState } from '../../../state/reducers';
import {
  clearAll,
} from '../../../state/exchange/updateAssetGameScheduleDialog';
import { queryGamesAction } from '../../../state/search';
import { updateAssetByExchangeScheduleId } from '../../../api/vault/assets';
import toast, { superAdminToast } from '../../../utils/toast';
import { Routes } from '../../../constants';
import { selectIsUserVaultSuperAdmin } from '../../../state/user/userOrgRole';

class UpdateAssetGameScheduleDialog extends PureComponent<IProps> {
  onSaveAsset = async () => {
    const {
      assetId: _id,
      selectedSchedule,
      onSearch,
      onExit,
    } = this.props;

    const result = await updateAssetByExchangeScheduleId(_id, selectedSchedule._id);

    if (result.status === 204) {
      const { location: { pathname: route } } = window;

      if (route === Routes.HOME) onSearch(1000);

      toast('Asset changes saved successfully', { type: toast.TYPE.SUCCESS });
    } else {
      toast('Error occurred while updating asset', { type: toast.TYPE.ERROR });
    }

    onExit();
  };

  render() {
    const {
      assetName,
      isOpen,
      selectedSchedule,
      gameDate,
      homeGameNumber,
      onExit,
    } = this.props;
    return (
      <Dialog
        open={isOpen}
        onClose={onExit}
        fullWidth
        maxWidth="md"
      >
        <DialogHeader>
          <DialogHeaderTitle
            data-auto="UpdateAssetScheduleModal"
          >
            Update Asset by Game Schedule
          </DialogHeaderTitle>
          <Typography
            align="center"
            variant="subtitle1"
            style={{
              width: '100%',
            }}
          >
            <VideoLabel
              fontSize="inherit"
              style={{
                position: 'relative',
                top: '3px',
              }}
            /> {assetName}
          </Typography>
        </DialogHeader>
        <GameScheduleForm />
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <Button
              variant="plainOnPaper"
              onClick={onExit}
              data-auto="CancelScheduleUpdate"
            >
              Cancel
            </Button>
            <Button
              variant="primaryOnWhite"
              onClick={() => this.onSaveAsset()}
              disabled={!selectedSchedule || !gameDate || !homeGameNumber}
              data-auto="SaveScheduleUpdate"
            >
              Save
            </Button>
          </ActionContainer>
        </DialogActionsOverride>
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.updateAssetGameScheduleDialog.isOpen,
  selectedSchedule: state.exchange.gameScheduleForm.selectedSchedule,
  gameDate: state.exchange.gameScheduleForm.gameDate,
  homeGameNumber: state.exchange.gameScheduleForm.homeGameNumber,
});

const mapDispatchToProps: IDispatchProps = {
  onSearch: queryGamesAction,
  onExit: clearAll,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateAssetGameScheduleDialog);
